import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Col,
    Row,
    Card
} from "reactstrap";
import styles from './styles.module.scss';
import Link from "next/link"

export default function AllSpecialisms({
    global,
    pathPrefix,
    customClass = "",
    all_specialisms,
    buttonTitle,
    specialismPath
}) {

    return (
        all_specialisms.length >= 1 && (
            <section className={`${styles.root} ${customClass}`}>
                <Container>
                    <Row>
                        {all_specialisms?.map((post, index) => (
                            <>
                                <Col md={6} lg={4} key={index} className="mb-4">
                                    <Link href={`${specialismPath}/${post.url_slug}/`}>
                                        <a className="text-decoration-none">
                                            <Card className="rounded-3 overflow-hidden h-100">
                                                <SourceFlowImage
                                                    src={post?.preview_image ? post.preview_image : "/site-assets/images/specialisms-default-preview-image.jpg"}
                                                    size="800x800"
                                                    alt={post.title}
                                                    className="card-img rounded-0 position-absolute"
                                                    width="100%"
                                                    height="100%"
                                                />
                                                <div className="p-4 position-relative content-wrapper">
                                                    <h5 className="text-white">{post.title}</h5>
                                                    <div className="mt-4">
                                                        <span className="primaryBtn-outline-white">
                                                            <SourceFlowText global={global} path={`${pathPrefix}.buttonTitle`}>
                                                                {buttonTitle}
                                                            </SourceFlowText>
                                                        </span>
                                                    </div>
                                                </div>
                                            </Card>
                                        </a>
                                    </Link>
                                </Col>
                            </>
                        ))}
                    </Row>
                </Container>
            </section>
        )
    )
}